<template>
  <div id="header">
    <v-app-bar height="70px" color="transparent" light class="px-6 header-bar" fixed dense>
      <!-- Logo -->
      <div class="header-logo">
        <app-header-logo />
      </div>

      <v-spacer></v-spacer>

      <!-- Right side -->
      <div class="header-right">
        <!-- Licensed only stays in header -->
        <div class="header-user-info">
          <div class="header-user-meta">
            <span class="header-meta-item">
              <v-icon size="11" class="mr-1" style="color:#94A3B8">mdi-shield-check-outline</v-icon>
              {{ $t('header.licensed') }}: <strong>{{ this.licenseName || 'Not Found' }}</strong>
            </span>
          </div>
        </div>

        <!-- Actions -->
        <div class="header-actions">
          <template v-if="userType"><app-admin-screen /></template>
          <app-lang-switch />
          <v-menu offset-y>
            <template v-slot:activator="{ on }">
              <button class="header-menu-btn" v-on="on">
                <v-icon size="18">mdi-dots-vertical</v-icon>
              </button>
            </template>
            <v-list class="header-dropdown" dense>
              <v-list-item
                v-for="link in links"
                :key="link.text"
                router
                :to="link.route"
                class="header-dropdown-item"
              >
                <v-list-item-title>{{ link.text }}</v-list-item-title>
              </v-list-item>
              <v-divider />
              <v-list-item class="header-dropdown-item header-logout" @click="logoutHandler">
                <v-icon size="15" class="mr-2">mdi-logout</v-icon>
                <v-list-item-title>{{ $t('logout') }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </div>
      </div>
    </v-app-bar>
  </div>
</template>

<script>
import LangSwitch from "./LangSwitch.vue";
import HeaderLogo from "./HeaderLogo.vue";
import AdminScreen from "./AdminScreen.vue";
import moment from "moment";

export default {

  components: {
    "app-lang-switch": LangSwitch,
    "app-header-logo": HeaderLogo,
    "app-admin-screen": AdminScreen,
  },

  data() {
    return {
      publicPath: process.env.BASE_URL,
      // links: [
      //   // { text: (this.$t('home')), route: "/" + this.$i18n.locale + "/dashboard" },
      //   {
      //     text: (this.$t('changepaswword')),
      //     route:
      //       "/" +
      //       this.$i18n.locale +
      //       "/changepassword/" +
      //       this.$store.getters.userId,
      //   },
      // ],
      links: [],
      licenseName: this.$store.getters.licenseName,
      lastAccess: moment(this.$store.getters.lastAccess).format("ll h:mm:ss A"),
      userType: null
    };
  },

  methods: {
    logoutHandler() {
      // this.$router.replace("/" + this.$i18n.locale + "/home/" + this.$store.getters.db);
      // this.$store.dispatch("deleteToken");

      const db = this.$store.getters.db;
      this.$store.dispatch("deleteToken");
      window.location.href = `/${this.$i18n.locale}/home/${db}`;

    }
  },

  mounted() {
    this.userType = (this.$store.getters.userType == 1 && this.$store.getters.psnId !== null) ? true : false

    if(this.$store.getters.userType == 1){
      this.links = [
        { text: (this.$t('home')), route: "/" + this.$i18n.locale + "/dashboard" },
        {
          text: (this.$t('changepaswword')),
          route:
            "/" +
            this.$i18n.locale +
            "/changepassword/" +
            this.$store.getters.userId,
        },
      ]
    } else {
      this.links = [
        // { text: (this.$t('home')), route: "/" + this.$i18n.locale + "/dashboard" },
        {
          text: (this.$t('changepaswword')),
          route:
            "/" +
            this.$i18n.locale +
            "/changepassword/" +
            this.$store.getters.userId,
        },
      ]
    }

    //console.log(this.userType)//why even console log show this
    
    // if(this.userType == true) {
    //   this.links = this.links;
    // } else {
    //   this.links = [
    //     {
    //       text: (this.$t('changepaswword')),
    //       route:
    //         "/" +
    //         this.$i18n.locale +
    //         "/changepassword/" +
    //         this.$store.getters.userId,
    //     }
    //   ]
    // }
  }

  
};
</script>

<style scoped>
.header-bar {
  background: #F8FAFF !important;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06) !important;
  border-bottom: 1px solid #E8EDF5 !important;
}

.header-logo {
  display: flex;
  align-items: center;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 20px;
}

.header-user-info {
  text-align: right;
}

.header-user-name {
  font-size: 0.85rem;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 2px;
  justify-content: flex-end;
}

.header-user-name strong {
  color: #1E293B;
  margin-left: 3px;
}

.header-user-meta {
  display: flex;
  align-items: center;
  gap: 6px;
  justify-content: flex-end;
  margin-top: 2px;
}

.header-meta-item {
  font-size: 0.72rem;
  color: #64748B;
  display: flex;
  align-items: center;
}

.header-meta-item strong {
  color: #334155;
  margin-left: 2px;
}

.header-meta-sep {
  color: #CBD5E1;
  font-size: 0.72rem;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 6px;
}

.header-menu-btn {
  background: #EEF2FF;
  border: none;
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #4F6BFF;
  transition: all 0.15s;
}

.header-menu-btn:hover {
  background: #4F6BFF;
  color: #fff;
}

.header-dropdown {
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0,0,0,0.12) !important;
  border: 1px solid #E8EDF5 !important;
  min-width: 180px;
}

.header-dropdown-item {
  font-size: 0.85rem !important;
  color: #334155 !important;
  cursor: pointer;
}

.header-dropdown-item:hover {
  background: #EEF2FF !important;
  color: #4F6BFF !important;
}

.header-logout {
  color: #DC2626 !important;
  display: flex;
  align-items: center;
}

.header-logout:hover {
  background: #FEE2E2 !important;
}
</style>